var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar-wrapper",class:( _obj = {}, _obj['variant-'+_vm.variant] = _vm.variant, _obj )},[_c('div',{staticClass:"progress",style:({width: _vm.percentage + '%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }